"use client";

import React from "react";

import { viVN } from "@mui/material/locale";
import type {} from "@mui/lab/themeAugmentation";
import CssBaseline from "@mui/material/CssBaseline";
import type {} from "@mui/x-tree-view/themeAugmentation";
import type {} from "@mui/x-data-grid/themeAugmentation";
import type {} from "@mui/x-date-pickers/themeAugmentation";
import type {} from "@mui/material/themeCssVarsAugmentation";
import { AppRouterCacheProvider } from "@mui/material-nextjs/v14-appRouter";
import { Experimental_CssVarsProvider as CssVarsProvider } from "@mui/material/styles";

import { SettingsState } from "./types";
import { createTheme } from "./create-theme";
import { defaultSettings } from "./config-settings";
import { schemeConfig } from "./color-scheme-script";

// ----------------------------------------------------------------------

interface Props {
	children: React.ReactNode;
	settings?: SettingsState;
}

export function ThemeProvider({ children, settings = defaultSettings }: Props) {
	const theme = createTheme({ components: viVN.components }, settings);

	return (
		<AppRouterCacheProvider options={{ key: "css" }}>
			<CssVarsProvider
				theme={theme}
				defaultMode={schemeConfig.defaultMode}
				modeStorageKey={schemeConfig.modeStorageKey}
			>
				<CssBaseline />
				{children}
			</CssVarsProvider>
		</AppRouterCacheProvider>
	);
}
